import { render, staticRenderFns } from "./BetKings.vue?vue&type=template&id=92fb1bac&"
import script from "./BetKings.vue?vue&type=script&lang=js&"
export * from "./BetKings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports